import "./bootstrap"
import "./App.scss"

import "./reset.scss"
import Dashboard from "features/referral/Dashboard.page"
import Shopkeeper from "features/shopkeeper/Shopkeeper.page"
import { AdminLayout } from "features/site/Admin.layout"
import CreateStepper from "features/tokendistributor/CreateStepper.page"
import DistributeTokens from "features/tokendistributor/Distribute.page"
import SingleDistribution from "features/tokendistributor/SingleDistribution.page"
import useEagerConnect from "features/web3/useEagerConnect.hook"
import React from "react"
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"

function App() {
  useEagerConnect()

  return (
    <BrowserRouter>
      <Routes>
        <Route path={"/"} element={<AdminLayout />}>
          <Route path="create" element={<CreateStepper />} />

          <Route path="distribute" element={<DistributeTokens />} />
          <Route path="distribute/:distributionId" element={<SingleDistribution />} />
          <Route path="buy" element={<Shopkeeper />} />
          <Route path="referral" element={<Dashboard />} />
        </Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  )
}

export default React.memo(App)
